import React, { useEffect, useReducer, useState, useRef } from 'react';
import { Spin, Modal, notification, Upload, Popconfirm, message, Avatar, Empty, Input, AutoComplete, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker } from 'antd';
import { CheckCircleTwoTone, CheckCircleFilled } from "@ant-design/icons"
import './linkedMIDModal.css'
import { InfoCircleOutlined } from '@ant-design/icons';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../actions/index';
import NESARegistrations from "../MaintainAlumni/NESARegistrations";
import noAwardsPng from '../AlumniProfile/noawards.png'
import { object } from 'prop-types';
import NesaRegistrationsInfoModal from './NesaRegistationInfoModal';
import { isArray } from 'lodash';
import warningAlert from "../Membership/warning-alert.png";
import EagleRanks from '../MaintainAlumni/EagleRanks';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const currentDate = moment().format('MM/DD/YYYY');
const { Option } = Select;
const FormItem = Form.Item;

const initialState = {
    personGuidForUpdate: '',
    loadingHobbies: true, //for initial hobbies and Interests loading until get response from API
    loadingBusiness: true, //for initial Business and Career loading until get response from API
    loadingEmployer: true, //for initial Employer details loading until get response from API
    getOtherHobbies: false,
    isHobbiesHidden: false,
    isBusinessHidden: false,
    enableSaveHobbiesBtn: false,
    needToGetEmployerDetails: false,
    hobbies: [
        "Fishing", "Hunting", "Baseball", "Softball", "Golfing",
        "Jogging", "Competitive running", "Casual walking", "Other"
    ],
    getCurrentBusinessDetails: '',
    otherOccupations: '',
    getEmployerDetails: '',
    isRenderPopup: true
}

const maxLength = 100;
let chacheBusinessDetails = '';

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_PERSONGUID_FOR_UPDATE':
            return { ...state, personGuidForUpdate: action.personGuidForUpdate };
        
            case 'GET_OTHER_HOBBIES':
            return { ...state, getOtherHobbies: action.getOtherHobbies };

        case 'GET_OTHER_BUSINESS':
            return { ...state, getOtherBusiness: action.getOtherBusiness };

        case 'GET_EMPLOYER_DETAILS':
            return { ...state, needToGetEmployerDetails: action.needToGetEmployerDetails };

        case 'ENABLE_SAVE_HOBBIES_BTN':
            return { ...state, enableSaveHobbiesBtn: action.enableSaveHobbiesBtn };

        case 'SET_OTHER_OCCUPATION':
            return { ...state, otherOccupations: action.otherOccupations };

        case 'ENABLE_SAVE_BUSINESS_BTN':
            return { ...state, enableSaveBusinessBtn: action.enableSaveBusinessBtn };

        case 'ENABLE_SAVE_EMPLOYER_BTN':
            return { ...state, enableSaveEmployerBtn: action.enableSaveEmployerBtn };

        case 'SET_GET_HOBBIES':
            return { ...state, getHobbies: action.getExistingHobbies, getCombinedHobbies: action.getCombinedHobbies };

        case 'SET_GET_BUSINESS':
            return { ...state, getCurrentBusinessDetails: action.getCurrentBusinessDetails };

        case 'SET_GET_EMPOLYER':
            return { ...state, getEmployerDetails: action.getEmployerDetails };

        case 'SET_HOBBIES':
            return { ...state, hobbies: action.hobbies };

        case 'UPDATING_HOBBIES':
            return { ...state, loadingHobbies: action.loadingHobbies };

        case 'UPDATING_BUSINESS':
            return { ...state, loadingBusiness: action.loadingBusiness };

        case 'UPDATING_EMPLOYER':
            return { ...state, loadingEmployer: action.loadingEmployer };

        case 'SET_HOBBIES_PRIVATE':
            return { ...state, isHobbiesHidden: action.isHobbiesHidden };

        case 'SET_BUSINESS_PRIVATE':
            return { ...state, isBusinessHidden: action.isBusinessHidden };
        
        case 'SET_EMPLOYER_PRIVATE':
            return { ...state, isEmployerHidden: action.isEmployerHidden };


        default:
            return state;
    }
};


function HobbiesAndBusinessComponent(props) {
    const { getFieldDecorator } = props.form;

    const [state, dispatch] = useReducer(reducer, initialState);

    const PersonGUID = props.match.params.personGuid;

    const [inputValue, setInputValue] = useState('');

    const { pathname } = props.location;
    const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
    const userID = loggedinUser.account.userId || undefined;

    const isAlumniProfile = pathname.includes('/alumni-profile');
    const colSpan = isAlumniProfile ? 8 : 6;

    let isEditableHobbiesAndBusinessFrame, pathName, ForAdminView, forSelfView = false;
    let alumniPersonGuid = ''
    let frameHeight = '500px';
    let margin = '0px'
    console.log('location.pathname ', pathname);

    if (pathname === '/my-profile' || pathname === '/manage-memberid' || pathname == '/alumni-dashboard') {
        forSelfView = true;
        pathName = pathname
        frameHeight = '500px'
        isEditableHobbiesAndBusinessFrame = pathname === '/my-profile';
        margin = '-10px 0px 0px 0px'
    }
    else if (pathname.includes('/maintain-alumni') || pathname.includes('/list-and-search')) {
        ForAdminView = true;
        isEditableHobbiesAndBusinessFrame = true;
        pathName = pathname
        frameHeight = '500px'
        alumniPersonGuid = props.personGUID ? props.personGUID : PersonGUID;
        margin = '-100px 0px 0px 0px'
    }
    else {
        isEditableHobbiesAndBusinessFrame = false;
        frameHeight = '100%'
        // pathName = pathnames
    }

    useEffect(() => {
        props.actions.getOccupations()
        // if (forSelfView) {
        //     pathName != '/manage-memberid' ? props.actions.getmemberid(null, true, null, true, true) : ''
        //     props.actions.getAlumniAndLocalAwards()
        //     props.actions.getScoutingAffiliations()
        //     props.actions.getCouncilAffiliations()
        //     props.actions.getAffinityGroups()
        // }
        // else {
        //     props.actions.getOrUpdateAlumniPrivacyOptions(PersonGUID);
        // }
        // // if(props.forAlumniProfile){
        // //     let PersonGUID = props.match.params.personGuid

        // // }

    }, [])

    const getCombinedHobbies = (getExistingHobbies, personGuid) => {
        return getExistingHobbies.flatMap(item => {
            return item.attributeVal.includes(',')
                ? item.attributeVal.split(',').map(val => ({ ...item, attributeVal: val, personGuid, isCombinedHobby: true }))
                : { ...item, personGuid };
        });
    }

    const getBusinessDetails = (occupation) => {
        let businessDetails = occupation.trim();
        const foundOccupation = props.occupations.find(occ =>
            occ.name.toLowerCase() === businessDetails.toLowerCase()
        );

        if (foundOccupation) {
            businessDetails = foundOccupation.name;
        }
        else {
            businessDetails = `${businessDetails} (Other)`
        }

        return businessDetails;
    }

    useEffect(() => { //To manage Hobbies, Business and Employer details on my-profile and alumni Dashboard
        let personProfileAPIResponse = ForAdminView ? props.alumniProfileinfo : props.profileinfo; //On the Maintain-Alumni page, props.alumniProfileInfo contains the alumni's information, whereas props.profileInfo holds the admin's information.
        let personProfileLoading = ForAdminView ? props.alumniProfileLoading : props.profileloading; 
        let doesItMatchAlumnisProfile = (personProfileAPIResponse && personProfileAPIResponse.profile) ? alumniPersonGuid == personProfileAPIResponse.profile.personGuid : false; //To verify the API response that matches the personGuid present in the URL.
        let alumniProfileAPIResponse = props.alumniProfileinfo;

        let personGuid = '' 
        if((ForAdminView || forSelfView) && personProfileAPIResponse && personProfileAPIResponse.profile.personGuid) personGuid = personProfileAPIResponse.profile.personGuid;
        else if(!ForAdminView && alumniProfileAPIResponse && alumniProfileAPIResponse.personGuid) personGuid = alumniProfileAPIResponse.personGuid;

        if ((personProfileAPIResponse && personProfileAPIResponse.extendedProfile && (forSelfView || (ForAdminView && doesItMatchAlumnisProfile))) && !personProfileLoading) {
            const getExistingHobbies = personProfileAPIResponse.extendedProfile.filter(item => item.attributeId.toString() === '16');
            const {personGuid}  = personProfileAPIResponse.profile;


            const getHobbies = getExistingHobbies.length > 0 ? getCombinedHobbies(getExistingHobbies, personGuid) : []


            dispatch({ type: 'SET_GET_HOBBIES', getExistingHobbies, getCombinedHobbies: getHobbies })
            dispatch({ type: 'SET_PERSONGUID_FOR_UPDATE', personGuidForUpdate: personGuid })
            if (state.loadingHobbies) dispatch({ type: 'UPDATING_HOBBIES', loadingHobbies: false })
        }
        if ((Array.isArray(props.occupations) && props.occupations.length > 0)
            && (personProfileAPIResponse && (forSelfView || ForAdminView))
            && !personProfileLoading) {
            const { personGuid, occupation = '', employer = '' } = personProfileAPIResponse.profile;

            let businessDetails = (occupation && occupation.length > 0) ? getBusinessDetails(occupation) : ''

            dispatch({ type: 'SET_PERSONGUID_FOR_UPDATE', personGuidForUpdate: personGuid })
            dispatch({ type: 'SET_GET_BUSINESS', getCurrentBusinessDetails: businessDetails })
            dispatch({ type: 'SET_GET_EMPOLYER', getEmployerDetails: employer })
            if (state.loadingEmployer) dispatch({ type: 'UPDATING_EMPLOYER', loadingEmployer: false })
            if (chacheBusinessDetails.length > 0) chacheBusinessDetails = '';
            if(state.needToGetEmployerDetails && occupation.length !=0 && employer.length != 0 ) dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: false })
        }


        //For Alumni profile
        if (!ForAdminView && props.privacysettingsOptions && !props.isLoadingPrivacySettings) {
            if (((alumniProfileAPIResponse && alumniProfileAPIResponse.extendedProfileAttributes) && (props.privacysettingsOptions.isHobbiesAndInterestsDisplayed || (!props.privacysettingsOptions.isHobbiesAndInterestsDisplayed && props.isadmin)) && !forSelfView) && !props.alumniProfileLoading) {

                const getExistingHobbies = alumniProfileAPIResponse.extendedProfileAttributes.filter(item => item.attributeId.toString() === '16');
                const {personGuid} = alumniProfileAPIResponse;

                const getHobbies = getExistingHobbies.length > 0 ? getCombinedHobbies(getExistingHobbies, personGuid) : []


                dispatch({ type: 'SET_GET_HOBBIES', getExistingHobbies, getCombinedHobbies: getHobbies })
                dispatch({ type: 'SET_PERSONGUID_FOR_UPDATE', personGuidForUpdate: personGuid })
                if (state.loadingHobbies) dispatch({ type: 'UPDATING_HOBBIES', loadingHobbies: false })
            }
            else if (!props.privacysettingsOptions.isHobbiesAndInterestsDisplayed && !props.isadmin) dispatch({ type: 'SET_HOBBIES_PRIVATE', isHobbiesHidden: true })

            if ((Array.isArray(props.occupations) && props.occupations.length > 0)
                && (alumniProfileAPIResponse && alumniProfileAPIResponse.extendedProfileAttributes && !forSelfView && (props.privacysettingsOptions.isOccupationDisplayed || (!props.privacysettingsOptions.isOccupationDisplayed && props.isadmin)))
                && !props.alumniProfileLoading) {
                const { personGuid, occupation = '', employer } = alumniProfileAPIResponse;

                let businessDetails = (occupation && occupation.length > 0) ? getBusinessDetails(occupation) : ''

                dispatch({ type: 'SET_PERSONGUID_FOR_UPDATE', personGuidForUpdate: personGuid })
                dispatch({ type: 'SET_GET_BUSINESS', getCurrentBusinessDetails: businessDetails })
                if(state.needToGetEmployerDetails && occupation.length !=0 && employer.length != 0 ) dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: false })
                if (chacheBusinessDetails.length > 0) chacheBusinessDetails = '';
            }
            else if (!props.privacysettingsOptions.isOccupationDisplayed && !props.isadmin) dispatch({ type: 'SET_BUSINESS_PRIVATE', isBusinessHidden: true })

            if ((alumniProfileAPIResponse && !forSelfView && (props.privacysettingsOptions.isEmployerDisplayed || (!props.privacysettingsOptions.isEmployerDisplayed && props.isadmin)))
                && !props.alumniProfileLoading) {
                const { personGuid, occupation = '', employer = '' } = alumniProfileAPIResponse;

                dispatch({ type: 'SET_PERSONGUID_FOR_UPDATE', personGuidForUpdate: personGuid })
                dispatch({ type: 'SET_GET_EMPOLYER', getEmployerDetails: employer })
                dispatch({ type: 'SET_EMPLOYER_PRIVATE', isEmployerHidden: false })
                if (state.loadingEmployer) dispatch({ type: 'UPDATING_EMPLOYER', loadingEmployer: false })
                if(state.needToGetEmployerDetails && occupation.length !=0 && employer.length != 0 ) dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: false })
                if (chacheBusinessDetails.length > 0) chacheBusinessDetails = '';
            }
            else if (!props.privacysettingsOptions.isEmployerDisplayed && !props.isadmin) dispatch({ type: 'SET_EMPLOYER_PRIVATE', isEmployerHidden: true })
        }
        
        dispatch({ type: 'SET_PERSONGUID_FOR_UPDATE', personGuidForUpdate: personGuid })

    }, [props.profileinfo, props.profileloading, props.alumniProfileinfo, props.occupations, props.privacysettingsOptions, props.isLoadingPrivacySettings]);

    useEffect(() => {
        if (!props.businessUpdating && props.profileinfo && state.loadingBusiness) {
            dispatch({ type: 'UPDATING_BUSINESS', loadingBusiness: false })
            dispatch({ type: 'GET_OTHER_BUSINESS', getOtherBusiness: false })
            dispatch({ type: 'ENABLE_SAVE_BUSINESS_BTN', enableSaveBusinessBtn: false })
        }
    }, [props.businessUpdating])


    const renderHobbiesAndInterests = () => {
        let hobbyAndInterest = state.hobbies;
        return hobbyAndInterest.map((item, index) => {
            return <Option key={item}>{item}</Option>;
        })
    }

    const renderBusinessAndCareer = () => {
        if (Array.isArray(props.occupations) && props.occupations.length > 0) {
            return props.occupations
                .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name)) //to remove dublicates
                .sort((a, b) => { // To sort the array of objects in ascending order while ensuring that the "Other" option is always at the end
                    if (a.name === "Other") return 1;
                    if (b.name === "Other") return -1;
                    return a.name.localeCompare(b.name);
                })
                .map((item, index) => (
                    <Option key={item.id} value={item.name}>
                        {item.name}
                    </Option>
                ));
        }

        return null;
    }

    const handleChangeHobbiesAndInterests = (values) => {
        let hobbyAndInterest = state.hobbies;
        if (values.toLowerCase() == "other") {
            dispatch({ type: 'GET_OTHER_HOBBIES', getOtherHobbies: true })
        }
        else {
            dispatch({ type: 'GET_OTHER_HOBBIES', getOtherHobbies: false })
            dispatch({ type: 'ENABLE_SAVE_HOBBIES_BTN', enableSaveHobbiesBtn: false })
            dispatch({ type: 'UPDATING_HOBBIES', loadingHobbies: true })
            props.actions.addOrRemoveHobbies(values, state.personGuidForUpdate, 'add', ForAdminView)
        }
    }

    const handleChangeBusinessAndCareer = (values) => {
        if (values.toLowerCase() == "other") {
            dispatch({ type: 'GET_OTHER_BUSINESS', getOtherBusiness: true })
            if (!state.getCurrentBusinessDetails) dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: true })
        }
        else if(state.getEmployerDetails.length == 0){
            chacheBusinessDetails = values
            dispatch({ type: 'ENABLE_SAVE_BUSINESS_BTN', enableSaveBusinessBtn: false })
            dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: true })
        }
        else{
            // dispatch({ type: 'GET_OTHER_BUSINESS', getOtherBusiness: false })
            // dispatch({ type: 'ENABLE_SAVE_BUSINESS_BTN', enableSaveBusinessBtn: false })
            dispatch({ type: 'UPDATING_BUSINESS', loadingBusiness: true })
            // if (!state.getCurrentBusinessDetails) dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: true })
            // else 
            props.actions.updatedBusinessAndEmployerDetails(values, state.personGuidForUpdate, 'business', '', ForAdminView)
        }
    }

    const handleHobbiesSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { otherHobbies } = values;
                console.log('otherHobbies: ', otherHobbies);
                // props.actions.addOrRemoveHobbies(otherHobbies.includes(',') ? otherHobbies.split(',') : otherHobbies, state.personGuidForUpdate, 'add')
                dispatch({ type: 'UPDATING_HOBBIES', loadingHobbies: true })
                props.actions.addOrRemoveHobbies(otherHobbies, state.personGuidForUpdate, 'add', ForAdminView)
            }
        });
    }

    const handleBusinessSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { otherBusiness } = values;
                console.log('otherBusiness: ', otherBusiness);
                dispatch({ type: 'UPDATING_BUSINESS', loadingBusiness: true })
                props.actions.updatedBusinessAndEmployerDetails(otherBusiness, state.personGuidForUpdate, 'business', '', ForAdminView)
            }
        });

    }
    const handleEmployerSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { employerDetails } = values;
                console.log('employerDetails ', employerDetails);
                dispatch({ type: 'UPDATING_EMPLOYER', loadingEmployer: true })
                if(state.needToGetEmployerDetails) dispatch({ type: 'UPDATING_BUSINESS', loadingBusiness: true })
                values.businessDetails = chacheBusinessDetails ? chacheBusinessDetails : state.otherOccupations ? state.otherOccupations : ''
                props.actions.updatedBusinessAndEmployerDetails(values, state.personGuidForUpdate, 'employer', '', ForAdminView)
            }
        });

    }

    const renderPrivacyMessage = () => {
        return <Row className='width-100' type='flex' align='middle' justify='center' style={{height: '100%'}}>
            <Col className='center margin-top-10' xs={24} sm={24} md={24} lg={24} xl={24}>
                {/* <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
              </Col> */}

                <Row type='flex' align='bottom' justify='center'>
                    <span className='memb-exp'>Alum has identified this as private information!</span>
                </Row>
            </Col>
        </Row>
    }

    const renderNoRecordsFound = () => {
        return <Row className='width-100' type='flex' align='middle' justify='center' style={{height: '100%'}}>
            <Col className='center margin-top-10' xs={24} sm={24} md={24} lg={24} xl={24}>
                {/* <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
              </Col> */}

                <Row type='flex' align='bottom' justify='center'>
                    <span className='memb-exp'>No Records Found!</span>
                </Row>
            </Col>
        </Row>
    }

    const renderMyHobbiesAndInterests = () => {
        console.log('renderMyHobbiesAndInterests-isEditableHobbiesAndBusinessFrame', isEditableHobbiesAndBusinessFrame);
        const { getHobbies, getCombinedHobbies, loadingHobbies } = state;
        if ((props.hobbiesUpdating || props.profileloading || props.alumniProfileLoading) && loadingHobbies) {
            return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Hobbies and Interests..." />;
        }
        else if (Array, isArray(getCombinedHobbies) && getCombinedHobbies.length > 0) {

            return getCombinedHobbies.map(eachHobby => {
                return <div className='localawards' key={eachHobby.extendedProfileId}>
                    <Row type='flex' className='localawardssection' justify='flex-start' align='middle'>
                        <Col span={20}>
                            <Row type='flex' justify='flex-start' align='middle'>
                                <Col span={24}>
                                    <span className='m-l-20 award-name display-block'>{eachHobby.attributeVal}</span>
                                </Col>
                            </Row>
                        </Col>
                        {(isEditableHobbiesAndBusinessFrame) &&
                            <Col span={2}>
                                <Row type='flex' justify='flex-start' align='middle'>
                                    <Col span={24}>
                                        <Popconfirm
                                            title="Are you sure you want to delete this?"
                                            onConfirm={() => {
                                                if (eachHobby.isCombinedHobby) {
                                                    const getHobbyToRemove = getHobbies.filter(hobby => hobby.attributeId === eachHobby.attributeId);

                                                    const updatedHobbies = getHobbyToRemove.map(hobby => {
                                                        return {
                                                            ...hobby,
                                                            attributeVal: hobby.attributeVal.replace(eachHobby.attributeVal, '').split(',').filter(item => item.trim()).join(',')
                                                        };
                                                    });
                                                    props.actions.addOrRemoveHobbies(updatedHobbies[0], eachHobby.personGuid, 'update', ForAdminView)
                                                    // Dispatch or process updatedHobbies as needed
                                                } else props.actions.addOrRemoveHobbies(eachHobby, eachHobby.personGuid, 'delete', ForAdminView)
                                                dispatch({ type: 'UPDATING_HOBBIES', loadingHobbies: true })
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                                        </Popconfirm>
                                    </Col>
                                </Row>
                            </Col>
                        }
                    </Row>
                </div>
            })
        }
        else return renderNoRecordsFound();
    }

    const renderMyBusinessDetails = () => {
        const { getCurrentBusinessDetails, loadingBusiness } = state;
        if ((props.businessUpdating || props.profileloading || props.alumniProfileLoading) && loadingBusiness) {
            return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Business and Career..." />;
        }

        else if (getCurrentBusinessDetails && getCurrentBusinessDetails.length > 0) {
            return <div className='localawards' key={getCurrentBusinessDetails}>
                <Row type='flex' className='localawardssection' justify='flex-start' align='middle'>
                    <Col span={20}>
                        <Row type='flex' justify='flex-start' align='middle'>
                            <Col span={24}>
                                <span className='m-l-20 award-name display-block'>{getCurrentBusinessDetails}</span>
                            </Col>
                        </Row>
                    </Col>
                    {isEditableHobbiesAndBusinessFrame && <Col span={2}>
                            <Row type='flex' justify='flex-start' align='middle'>
                                <Col span={24}> 
                                    <Popconfirm
                                        title="Are you sure you want to delete this?"
                                        onConfirm={() => {
                                            dispatch({ type: 'UPDATING_BUSINESS', loadingBusiness: true })
                                            props.actions.updatedBusinessAndEmployerDetails('', state.personGuidForUpdate, '', 'business', ForAdminView)
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                                    </Popconfirm>
                                </Col>
                            </Row>
                        </Col> }
                </Row>
            </div>
        }
        else return renderNoRecordsFound();
    }

    const renderMyEmployerDetails = () => {
        const { getEmployerDetails, loadingEmployer } = state;
        if ((props.employerUpdating || props.profileloading || props.alumniProfileLoading) && loadingEmployer) {
            return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Employer Details..." />;
        }

        else if (getEmployerDetails && getEmployerDetails.length > 0) {
            return <div className='localawards' key={getEmployerDetails}>
                <Row type='flex' className='localawardssection' justify='flex-start' align='middle'>
                    <Col span={20}>
                        <Row type='flex' justify='flex-start' align='middle'>
                            <Col span={24}>
                                <span className='m-l-20 award-name display-block'>{getEmployerDetails}</span>
                            </Col>
                        </Row>
                    </Col>
                    {(isEditableHobbiesAndBusinessFrame) &&
                            <Col span={2}>
                                <Row type='flex' justify='flex-start' align='middle'>
                                    <Col span={24}>
                                        <Popconfirm
                                            title={ <span>
                                                Deleting the employer details will also<br />
                                                remove your business and career information.<br />
                                                Are you sure you want to proceed with this action?
                                            </span>}
                                            onConfirm={() => {
                                                props.actions.deleteEmployerDetails(state.personGuidForUpdate, ForAdminView)
                                                dispatch({ type: 'UPDATING_EMPLOYER', loadingEmployer: true })
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                                        </Popconfirm>
                                    </Col>
                                </Row>
                            </Col>
                        }
                </Row>
            </div>
        }
        else return renderNoRecordsFound();
    }


    return (
        <div className='hobbiesAndBusinessContainer' style={{ width: '100%' }}>
            <Col span={colSpan}>
                <div className='container min-height-710'>
                    <div className='widget-content' style={{ height: '100%' }}>
                        <Row type="flex" justify="space-between">
                            <div className='widget-header-text'>
                                My Hobbies And Interests
                            </div>
                        </Row>
                        <Row className={'widget-content-section height-360'} type="flex" style={state.getOtherHobbies ? { alignContent: 'flex-start' } : { alignContent: 'flex-start', height: frameHeight }} >
                            {(state.isHobbiesHidden && !forSelfView) ? renderPrivacyMessage() : renderMyHobbiesAndInterests()}
                        </Row>
                        {isEditableHobbiesAndBusinessFrame && <Row className='addLocalawards' style={{ margin: '10px 0px' }}>
                            <Col span={24}>
                                <span className='small-txt display-block'> Please add your Hobbies and Interests: </span>
                            </Col>
                            <Col span={24}>
                                <Select
                                    className='awardsselect'
                                    showSearch
                                    // mode="multiple"
                                    optionLabelProp="label"
                                    style={{ width: "100%" }}
                                    // notFoundContent={null}
                                    filterOption={(input, option) => {
                                        const children = option.props.children;
                                        return typeof children === 'string' && children.toLowerCase().includes(input.toLowerCase());
                                    }
                                    }
                                    onChange={e => handleChangeHobbiesAndInterests(e)}

                                >
                                    {renderHobbiesAndInterests()}

                                </Select>
                            </Col>
                        </Row>}
                        {isEditableHobbiesAndBusinessFrame && state.getOtherHobbies ? <div className='edit-mode my-profile alumni-ui m-0-p-0' >
                            <Form onSubmit={handleHobbiesSubmit} className="alumni-info-form m-0-p-0">
                                <Row type='flex' justify='start' className='m-0-p-0'>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <FormItem
                                            label=""
                                            className='m-0-p-0'
                                        >
                                            {getFieldDecorator('otherHobbies', {
                                                initialValue: '',
                                                rules: [
                                                    {
                                                        required: true,
                                                        // message: ‘You can enter multiple hobbies, separated by commas!’
                                                    }
                                                ],
                                            })(
                                                <span>
                                                    {/* <p className=‘SocialMedioValidateInfo’ style={{margin: ‘5px 0’, display: ‘inline-block’, lineHeight: ‘1.5’, padding: "0"}} ><InfoCircleOutlined /> You can enter multiple hobbies, separated by commas!</p> */}
                                                    <Input placeholder="Other Hobbies and Interests" name="Hobbies" onChange={(e) => e.target.value.length > 0 ? dispatch({ type: 'ENABLE_SAVE_HOBBIES_BTN', enableSaveHobbiesBtn: true }) : ""} />
                                                </span>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row type='flex' className='btn-action m-0-p-0' justify='space-around'>
                                    <Col xs={23} sm={23} md={24} lg={24} xl={24} className='m-0-p-0'>
                                        <Row type='flex' justify='space-around' className='m-0-p-0'>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='m-0-p-0'>
                                                <FormItem style={{ padding: '10px 0px', margin: '0px' }}>
                                                    <Button disabled={!state.enableSaveHobbiesBtn} id="myprofile-info-sb-btn" className="myprofile-info-sb-btn hobbySave-btn" style={{ margin: '0px', height: '56px' }} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </div> : null}

                    </div>
                </div>
            </Col>

            {/* MY BUSINESS AND CAREER DETAILS */}
            <Col span={colSpan} >
                <div className='container min-height-710'>
                    <div className='widget-content' style={{ height: '100%' }}>
                        <Row type="flex" justify="space-between">
                            <div className='widget-header-text'>
                                MY BUSINESS AND CAREER
                            </div>
                        </Row>
                        <Row className={state.getOtherBusiness ? 'widget-content-section height-300' : 'widget-content-section height-360'} type="flex"
                            style={state.getOtherBusiness ? { alignContent: 'flex-start' } : { alignContent: 'flex-start', height: frameHeight }}
                        >
                            {(state.isBusinessHidden && !forSelfView) ? renderPrivacyMessage() : renderMyBusinessDetails()}
                        </Row>
                        {isEditableHobbiesAndBusinessFrame && <Row className='addLocalawards' style={{ margin: '10px 0px' }}>
                            <Col span={24}>
                                <span className='small-txt display-block'> Please add your Business and Career: </span>
                            </Col>
                            <Col span={24}>
                                <Select
                                    className='awardsselect'
                                    showSearch
                                    // mode="multiple"
                                    optionLabelProp="label"
                                    style={{ width: "100%" }}
                                    // notFoundContent={null}
                                    filterOption={(input, option) => {
                                        const children = option.props.children;
                                        return typeof children === 'string' && children.toLowerCase().includes(input.toLowerCase());
                                    }
                                    }
                                    onChange={e => handleChangeBusinessAndCareer(e)}

                                >
                                    {renderBusinessAndCareer()}

                                </Select>
                            </Col>
                        </Row>}
                        {isEditableHobbiesAndBusinessFrame && state.getOtherBusiness ? <div className='edit-mode my-profile alumni-ui m-0-p-0' >
                            <Form onSubmit={handleBusinessSubmit} className="alumni-info-form m-0-p-0">
                                <Row type='flex' justify='start' className='m-0-p-0'>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ height: '125px' }}>
                                        <FormItem
                                            label=""
                                            className='m-0-p-0'
                                        >
                                            {getFieldDecorator('otherBusiness', {
                                                initialValue: "",
                                                rules: [
                                                    {
                                                        pattern: /^[a-zA-Z, ]+$/,
                                                        message: 'Numbers and Special characters are not allowed!',
                                                    },
                                                    {
                                                        required: true, message: 'Please enter your Other Business & Career.'
                                                    },
                                                    {
                                                        validator: (rule, value, callback) => {
                                                            const maxLength = 100;
                                                            if (value && `${Number(value.length)}` > maxLength) {
                                                                value = value.slice(0, maxLength);
                                                                callback(`Maximum character limit (${maxLength}) reached!`);
                                                            } else {
                                                                callback();
                                                            }
                                                        },
                                                    }
                                                ],
                                            })(
                                                <span>
                                                    <Input maxLength={100} placeholder='Other Business and Interests' name='Business'
                                                        onChange={(e) => {
                                                            if (e.target.value.length > 0) {
                                                                dispatch({ type: 'ENABLE_SAVE_BUSINESS_BTN', enableSaveBusinessBtn: true })
                                                                dispatch({ type: 'SET_OTHER_OCCUPATION', otherOccupations: e.target.value })
                                                                if (state.needToGetEmployerDetails) {
                                                                    chacheBusinessDetails = e.target.value;
                                                                    dispatch({ type: 'GET_EMPLOYER_DETAILS', needToGetEmployerDetails: true})
                                                                }
                                                            }
                                                        }} />
                                                    <p style={{ margin: '5px 0', display: '', lineHeight: '1.5', padding: "0" }} >{maxLength - Number(state.otherOccupations.length)} characters remaining!</p>
                                                </span>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                {/* //Hide the Save business details button if we need to collect employer information. 
                                Since the user is entering business details for the first time, the API requires the "employer" value. */}
                                {!state.needToGetEmployerDetails && <Row type='flex' className='btn-action m-0-p-0' justify='space-around'>
                                    <Col xs={23} sm={23} md={24} lg={24} xl={24} className='m-0-p-0'>
                                        <Row type='flex' justify='space-around' className='m-0-p-0'>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='m-0-p-0'>
                                                <FormItem style={{ padding: '10px 0px', margin: '0px' }}>
                                                    <Button disabled={!state.enableSaveBusinessBtn} id="myprofile-info-sb-btn" className="myprofile-info-sb-btn hobbySave-btn" style={{ margin: '0px', height: '56px' }} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>}
                            </Form>
                        </div> : null}

                    </div>
                </div>
            </Col>

            {/* EMPLOYER DETAILS */}
            <Col span={colSpan}>
                <div className='container min-height-710'>
                    <div className='widget-content' style={{ height: '100%' }}>
                        <Row type="flex" justify="space-between">
                            <div className='widget-header-text'>
                                EMPLOYER
                            </div>
                        </Row>
                        <Row className={'widget-content-section height-360'} type="flex" style={forSelfView ? { alignContent: 'flex-start', height: '430px' } : { alignContent: 'flex-start', height: frameHeight }} >
                            {(state.isEmployerHidden && !forSelfView) ? renderPrivacyMessage() : renderMyEmployerDetails()}
                        </Row>
                        {isEditableHobbiesAndBusinessFrame && <Row className='addLocalawards' style={{ margin }}>
                            <Col span={24}>
                                <span className='small-txt display-block'> Please add your Employer details: </span>
                            </Col>
                            {/* <Col span={24}>
                                <Select
                                    className='awardsselect'
                                    showSearch
                                    // mode="multiple"
                                    optionLabelProp="label"
                                    style={{ width: "100%" }}
                                    // notFoundContent={null}
                                    filterOption={(input, option) => {
                                        const children = option.props.children;
                                        return typeof children === 'string' && children.toLowerCase().includes(input.toLowerCase());
                                    }
                                    }
                                    onChange={e => handleChangeHobbiesAndInterests(e)}

                                >
                                    {renderHobbiesAndInterests()}

                                </Select>
                            </Col>*/}

                            <div className='edit-mode my-profile alumni-ui m-0-p-0' >
                                <Form onSubmit={handleEmployerSubmit} className="alumni-info-form m-0-p-0">
                                    <Row type='flex' justify='start' className='m-0-p-0'>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <FormItem
                                                label=""
                                                className='m-0-p-0'
                                                style={{ minHeight: '100px' }}
                                                hasFeedback
                                                validateStatus={state.needToGetEmployerDetails ? "error" : undefined}
                                                help={state.needToGetEmployerDetails ? "Please enter your employer details!" : undefined}
                                            >
                                                {getFieldDecorator('employerDetails', {
                                                    initialValue: "",
                                                    rules: [
                                                        {
                                                            required: state.needToGetEmployerDetails,
                                                        }
                                                    ],
                                                })(
                                                    <span>
                                                        {/* <p className='SocialMedioValidateInfo' style={{margin: '5px 0', display: 'inline-block', lineHeight: '1.5', padding: "0"}} ><InfoCircleOutlined /> You can enter multiple hobbies, separated by commas!</p> */}
                                                        <Input placeholder="Employer Details" name="Hobbies" onChange={(e) => (e.target.value.length > 0 || state.needToGetEmployerDetails) ? dispatch({ type: "ENABLE_SAVE_EMPLOYER_BTN", enableSaveEmployerBtn: true }) : ''} />
                                                    </span>
                                                )}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row type='flex' className='btn-action m-0-p-0' justify='space-around'>
                                        <Col xs={23} sm={23} md={24} lg={24} xl={24} className='m-0-p-0'>
                                            <Row type='flex' justify='space-around' className='m-0-p-0'>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='m-0-p-0'>
                                                    <FormItem style={{ padding: '10px 0px', margin: '0px' }}>
                                                        <Button disabled={!state.enableSaveEmployerBtn} id="myprofile-info-sb-btn" className="myprofile-info-sb-btn hobbySave-btn" style={{ margin: '0px', height: '56px' }} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Row>}
                    </div>
                </div>
            </Col>

            {!pathname.includes('/alumni-profile') && (
                <Col style={{ width: '25%' }}>
                    <EagleRanks eagleInfo = {props.eagleInfo}/>
                </Col>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    hobbiesUpdating: state.hobbiesAndBusinessReducer.hobbiesUpdating,
    businessUpdating: state.hobbiesAndBusinessReducer.businessUpdating,
    employerUpdating: state.hobbiesAndBusinessReducer.employerUpdating,

    profileloading: state.profilereducer.loading,
    profileinfo: state.profilereducer.profileinfo,

    occupationLoading: state.occupationsreducer.loading,
    occupations: state.occupationsreducer.occupations,

    alumniProfileinfo: state.alumniinforeducer.profileinfo,
    alumniProfileLoading: state.alumniinforeducer.loading,

    privacysettingsOptions: state.alumniPrivacyOptionsreducer.privacysettingsOptions,
    isLoadingPrivacySettings: state.alumniPrivacyOptionsreducer.loading,

    isadmin: state.isadminreducer.isadmin,

    eagleInfo: (state.alumnieagleinforeducer && state.alumnieagleinforeducer.eagleinfo && Object.keys(state.alumnieagleinforeducer.eagleinfo).length > 0)
        ? state.alumnieagleinforeducer.eagleinfo
        : state.eagleinforeducer.eagleinfo,
        
    // nesa_loading: state.nesaregistrationreducer.loading,
    // nesa_reg: state.nesaregistrationreducer.reg,
    // localAwards_Loading: state.localAwardsReducer.loading,


    // awardsloading: state.awardsreducer.loading,
    // awards: state.awardsreducer.awards,
    // alumniAwards: state.alumniawardsreducer.awards,
    // affinities_loading: state.affinitiesreducer.loading,
    // affinities: state.affinitiesreducer.affinities,
    // localAwards: state.localAwardsReducer.localAwards,
    // scoutings_loading: state.scoutingsreducer.loading,
    // scoutings: state.scoutingsreducer.scoutings,
    // scoutings_deleting: state.scoutingsdeletereducer.loading,
    // scoutings_adding: state.scoutingsaddreducer.loading,
    // councils: state.councilsreducer.councils,
    // councils_adding: state.councilsaddreducer.loading,
    // councils_deleting: state.councildeletereducer.loading,
    // memberids: state.getmemberidreducer.memberids,
    // alumniAndLocalAwardsReducerState: state.getAlumniAndLocalAwardsReducer.alumniAndLocalAwards,
    // loadingAlumniAndLocalAwards: state.getAlumniAndLocalAwardsReducer.loading,
    // scoutingAffiliationsReducerState: state.getScoutingAffiliationsReducer.scoutingAffiliations,
    // scoutingAffiliationsLoading: state.getScoutingAffiliationsReducer.loading,
    // councilAffiliationsReducerState: state.getCouncilAffiliationsReducer.councilAffiliations,
    // councilAffiliationsLoading: state.getCouncilAffiliationsReducer.loading,
    // affinityGroupsReducerState: state.getAffinityGropusReducer.affinityGroups,
    // affinityGroupsLoading: state.getAffinityGropusReducer.loading,


});

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default Form.create()(withRouter(connect(mapStateToProps, mapDispatchToProps)(HobbiesAndBusinessComponent)));


// WEBPACK FOOTER //
// ./src/components/Inc/HobbiesAndBusiness.js